import { ref, watch, onUnmounted } from 'vue';
import { windowHasFeature } from '../utils/window';
export function useResizeObserver(target, callback, options = {}) {
    let observer;
    const rect = ref();
    const listener = (...args) => {
        if (callback)
            callback(...args);
        const entry = args[0][0];
        rect.value = entry.contentRect;
    };
    const stopObserver = () => {
        if (observer) {
            observer.disconnect();
            observer = undefined;
        }
    };
    const stopWatch = watch(() => target.value, (elOrComp) => {
        stopObserver();
        if (windowHasFeature('ResizeObserver') && elOrComp) {
            observer = new ResizeObserver(listener);
            observer.observe(elOrComp.$el ?? elOrComp, options);
        }
    }, { immediate: true, flush: 'post' });
    const cleanup = () => {
        stopObserver();
        stopWatch();
    };
    onUnmounted(() => cleanup());
    return { rect, cleanup };
}
//# sourceMappingURL=resizeObserver.js.map